var _dec, _class, _AudioSignal;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { requestAnimationFrame } from '@instructure/ui-dom-utils';
import { withStyle, jsx } from '@instructure/emotion';
import { translate } from '../../../constants/translated/translations';
import generateStyle from './styles';
import generateComponentTheme from './theme';
const MULTIPLIER = 1.5;
/**
---
private: true
---
**/
let AudioSignal = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_AudioSignal = class AudioSignal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0
    };
    this.raf = [];
  }
  componentDidMount() {
    this.raf.push(requestAnimationFrame(() => {
      this.getVolume();
    }));
    this.props.makeStyles();
  }
  componentDidUpdate() {
    this.props.makeStyles();
  }
  componentWillUnmount() {
    this.raf.forEach(request => {
      request.cancel();
    });
    this.raf = [];
  }
  getVolume() {
    const soundMeter = this.props.soundMeter;
    const volume = Math.floor(soundMeter.volume * 100) * MULTIPLIER;
    if (volume !== this.state.value) {
      this.setState({
        value: volume
      });
    }
    this.raf.push(requestAnimationFrame(() => {
      this.getVolume();
    }));
  }
  render() {
    const styles = this.props.styles;
    return jsx("meter", {
      css: styles.meter,
      "aria-label": translate('ARIA_VOLUME'),
      min: "0",
      max: "100",
      low: "30",
      optimum: "90",
      high: "95",
      value: this.state.value
    });
  }
}, _AudioSignal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  makeStyles: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  styles: PropTypes.object,
  soundMeter: PropTypes.shape({
    volume: PropTypes.number.isRequired
  }).isRequired
}, _AudioSignal)) || _class);
const mapStateToProps = state => ({
  soundMeter: state.soundMeter
});
export default connect(mapStateToProps)(AudioSignal);